module.exports = __webpack_public_path__ + "static/media/logoBanader.32be53b7.png";